import React from "react"
//import styles from "./ExternalLink.module.scss"

const ExternalLink = ({ ...rest }) => {
  //console.log('Rendering ExternalLink', props)
  return <a target="_blank" rel="nofollow noopener" {...rest} />
}

export default ExternalLink
